import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem('b360_cart');
    return saved ? JSON.parse(saved) : [];
  });

  const [bookmarks, setBookmarks] = useState(() => {
    const saved = localStorage.getItem('b360_bookmarks');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('b360_cart', JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem('b360_bookmarks', JSON.stringify(bookmarks));
  }, [bookmarks]);

  const addToCart = (assessment, type = 'ai') => {
    const cartId = `${assessment.id}-${type}`;
    setCart(prev => {
      if (prev.find(item => item.cartId === cartId)) return prev;
      return [...prev, { 
        ...assessment, 
        cartId, 
        purchaseType: type,
        price: type === 'expert' ? assessment.priceExpert : assessment.priceAI 
      }];
    });
  };

  const removeFromCart = (cartId) => {
    setCart(prev => prev.filter(item => item.cartId !== cartId));
  };

  const toggleBookmark = (id) => {
    setBookmarks(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const clearCart = () => setCart([]);

  const cartTotal = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <CartContext.Provider value={{ 
      cart, bookmarks, addToCart, removeFromCart, toggleBookmark, clearCart, cartTotal 
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);